<template>
    <div v-if="authUserPermission['kpi-catalog-status-view']">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0"></h6>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--6 header-body">
            <div class="card mb-4">
                <div class="card-header">
                    <div class="row">
                        <div class="col">
                            <h3 class="mb-0">{{ tt('kpi_catalog_status') }}</h3>
                        </div>
                        <div class="col text-right">
                            <a v-if="authUserPermission['kpi-catalog-status-export']" :href="exportLink" class="btn btn-sm btn-outline-dark">
                                {{ tt('export_as_excel') }}
                            </a>
                            <a class="btn btn-sm btn-outline-dark" @click="showFilterModal()">
                                {{ tt('filter') }}
                            </a>
                        </div>
                    </div>
                </div>
                <div class="table-responsive" style="height: 500px" v-if="!onLoad">
                    <table class="table">
                        <thead>
                            <tr>
                                <th class="text-center" :colspan="catalogData.length + 4">
                                    <span v-if="dataFilter.start_date"> {{ dataFilter.start_date }} {{ dataFilter.end_date }} </span>
                                </th>
                            </tr>
                            <tr>
                                <th>{{ tt('company_code') }}</th>
                                <th>{{ tt('name') }}</th>
                                <th>{{ tt('role') }}</th>
                                <th class="text-center" v-for="x in catalogData" :key="x.code">{{ x.code }}</th>
                                <th>{{  tt('total') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(kpi,index) in kpiData" :key="index">
                                <td v-if="company === 'All'">All</td>
                                <td v-else>{{ company }} {{ plant }}</td>
                                <td>{{  kpi.name }}</td>
                                <td>
                                   <button class="btn btn-sm btn-primary" v-for="(role, indexRole) in kpi.roles" :key="indexRole"> {{  role.name  }} </button>
                                </td>
                                <td v-for="(kpiCat, indexCat) in kpi.cat_status_count" :key="indexCat">
                                        {{ kpiCat.cat_status_count }}
                                </td>
                                <td>{{ kpi.total }}</td>
                            </tr>
                        </tbody>
                     
                    </table>
                </div>
                <skeleton-loading v-else></skeleton-loading>
            </div>
        </div>
        
        <modal :show.sync="formSearch.show">
            <template slot="header">
                <h5 class="modal-title">{{ tt('filter') }}</h5>
            </template>
            <div>
                <div class="form-group">
                    <el-select clearable filterable multiple reserve-keyword remote :remote-method="queryCatalogStatus" class="select-danger" v-model="dataFilter.catalog_status" :placeholder="tt('choose_catalog_status')">
                        <el-option class="select-danger" :value="ct.code" :label="ct.code + ' - ' + ct.description" :key="ct.code" v-for="ct in optionCatalog">{{ ct.code + ' - ' + ct.description}}</el-option>
                    </el-select>
                </div>      
                <div class="form-group">
                    <el-select clearable filterable class="select-danger" 
                    v-model="dataFilter.company" 
                    :placeholder="tt('choose_company')" 
                    :remote-method="queryCompany"
                     remote
                     reserve-keyword
                     :loading="selectSearch.companyLoad">
                        <el-option class="select-danger" :value="cm.company_code" :label="cm.company_code + ' - ' + cm.company_description" :key="cm.company_code" v-for="cm in companyData">{{ cm.company_code + ' - ' + cm.company_description}}</el-option>
                    </el-select>
                </div>       
                <div class="form-group">
                    <el-select clearable filterable class="select-danger" v-model="dataFilter.plant" :placeholder="tt('choose_plant')">
                        <el-option class="select-danger" :value="ct.plant_code" :label="ct.plant_code + ' - ' + ct.description" :key="ct.plant_code" v-for="ct in plantData">{{ ct.plant_code + ' - ' + ct.description}}</el-option>
                    </el-select>
                </div> 
                 <div class="form-group">
                    <el-select filterable class="select-danger" clearable
                    remote 
                    reserve-keyword
                    :remote-method="queryCataloguedBy"
                    :loading="selectSearch.userNameLoad"
                    v-model="dataFilter.username" :placeholder="tt('catalogued_by')"
                    >
                    <el-option v-for="item in userData" :key="item.value" :value="item.namecode" :label="item.username + ' - ' + item.name"> </el-option>
                </el-select>
                </div>      

                <div>
                    <el-date-picker
                    v-model="dataFilter.date"
                    type="daterange"
                    start-placeholder="Start Date"
                    end-placeholder="End Date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd" style="width:100%" clearable  >
                    </el-date-picker>
                </div>
            </div>
            <template slot="footer">
                <base-button type="secondary" @click="formSearch.show = false">{{ tt('close') }}</base-button>
                <base-button type="primary" :disabled="btnSearch.onLoading" @click="handleFilter()">
                    <span v-if="btnSearch.onLoading"><i class="fas fa-spinner fa-spin"></i> {{ tt('please_wait') }}</span>
                    <span v-else>
                        {{tt('search')}}
                    </span>
                </base-button>
            </template>
        </modal>
    </div>
    <noaccess v-else/>

</template>
<script>
	import {mapState} from "vuex";
	import Api from '@/helpers/api';
    import catalogStatus from '@/services/master/catalogStatus.service';
    import companyCode from '@/services/master/companyCode.service';
    import plantCode from '@/services/master/plantCode.service';
    import catalogBy from '@/services/manage/manageAccount.service';
    import KpiCatalogStatus from '@/services/report/kpiCatalogStatus.service';
    import config from '@/configs/config';


	export default {
		data() {
			return {
                search : '',
                catalogData: [],
                companyData: [],
                optionCatalog: [],
                plantData:[],
                userData:[],
				token: localStorage.getItem('token'),
                dataFilter: {
                    catalog_status:[],
                    start_date:'',
                    end_date: '',
                    company:'',
                    plant:'',
                    username:'',
                    date: ''
                },
                kpiData:[],
                btnSearch: {
                    onLoading: false
                }, 
                formSearch:{
                    show: false
                },
                selectSearch: {
                    companyLoad: false,
                    plantLoad: false,
                    userNameLoad: false,

                },
                company: '',
                plant: '',
                onLoad: false,
                apiUrl: config.apiUrl,
                exportLink: ''
			}
		},
		computed: {
			...mapState({
				authUserPermission :state => state.auth.userPermission
			}),
		},
        watch: {
            'dataFilter.company': function(val){
                this.dependCompany()
            }
        },
		mounted() {

			this.getCatalogStatus();
            this.getDataKpi();
		},
		methods: {
             getCatalogStatus(param = '') { 
                let context = this;           
                Api(context, catalogStatus.get(null, {search: param})).onSuccess(function(response) {    
                    context.catalogData  = response.data.data.data.data;   
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.catalogData = [];
                    }
                })
                .call()
            },
            showFilterModal(){
                this.formSearch.show = true
            },
            handleFilter(){
                this.formSearch.show = false;
                this.getDataKpi()
            },
            getDataKpi(){
                let context = this;
                this.onLoad = true;
                
                if(this.dataFilter.date != null ){
                    this.dataFilter.start_date =  this.dataFilter.date[0] ?? ''
                    this.dataFilter.end_date =  this.dataFilter.date[1] ?? ''
                }else{
                    this.dataFilter.start_date =  ''
                    this.dataFilter.end_date =  ''
                }
                Api(context, KpiCatalogStatus.get({
                    company: this.dataFilter.company ?? '',
                    plant: this.dataFilter.plant ?? '',
                    namecode: this.dataFilter.username ?? '',
                    start_date: this.dataFilter.start_date ?? '',
                    end_date: this.dataFilter.end_date ?? '',
                    catalog_status: this.dataFilter.catalog_status,     
                }))
                .onSuccess(function(response) {
                    context.catalogData = response.data.data.catalog_status
                    context.kpiData = response.data.data.data
                    context.company = response.data.data.company
                    context.plant = response.data.data.plant
                }).onError(function(error) {
                    context.catalogData = []
                    context.kpiData = []
                }).onFinish(function(){
                    context.onLoad = false;
                    context.generateLink()
                }).call(); 
            },
            queryCompany(query) {
            if (query !== '') {
                if (query.length > 1) {
                        clearTimeout(this.selectSearch.loadTimeout);
                        let context = this;

                        this.selectSearch.companyLoad = true;

                        this.selectSearch.loadTimeout = setTimeout(() => {
                            Api(context, companyCode.get(null, { per_page: 'none', search: query })).onSuccess(function (response) {
                                context.companyData = response.data.data.data.data;
                                context.selectSearch.companyLoad = false;
                            }).onError(function (error) {
                                context.companyData = [];
                                context.selectSearch.companyLoad = false;
                            }).call();
                        }, 200)
                    }
                } else {
                    this.optionCompany = [];
                }
            },
            dependCompany(){
                    let context = this;
                    this.dataFilter.plant = ''

                    Api(context, plantCode.companyPlant({company_code: this.dataFilter.company} ))
                    .onSuccess(function(response) {
                        context.plantData = response.data.data;                         
                        context.selectSearch.plantLoad = false;
                    }).onError(function(error) {
                        context.plantData = [];
                         context.selectSearch.plantLoad = false;
                    }).call();  
            },
            queryCataloguedBy(query) {
                if (query !== '') {
                    if (query.length > 1) {
                        clearTimeout(this.selectSearch.loadTimeout);
                        let context = this;

                        this.selectSearch.userNameLoad = true;

                        this.selectSearch.loadTimeout = setTimeout(() => {
                            Api(context, catalogBy.get(null, { per_page: 'none', search: query })).onSuccess(function (response) {
                                context.userData = response.data.data.data.data;
                                context.selectSearch.userNameLoad = false;
                            }).onError(function (error) {
                                context.userData = [];
                                context.selectSearch.userNameLoad = false;
                            }).call();
                        }, 200)
                    }
                } else {
                    this.optionCataloguedBy = []
                }
            },
             queryCatalogStatus(query) { 
                let context = this;           
                Api(context, catalogStatus.get(null, {search: query})).onSuccess(function(response) {    
                    context.optionCatalog  = response.data.data.data.data;   
                }).onError(function(error) {                    
                    if (error.response.status == 404) {
                        context.optionCatalog = [];
                    }
                })
                .call()
            },
            generateLink(){
                const baseUrl = this.apiUrl + '/KpiCatalogStatus/export';
                const params = new URLSearchParams();
                params.append('export', 'Excel')
                params.append('token', this.token)
                params.append('namecode', this.dataFilter.username ?? '')
                params.append('company', this.dataFilter.company ?? '')
                params.append('plant', this.dataFilter.plant ?? '')
                params.append('start_date', this.dataFilter.start_date ?? '')
                params.append('end_date', this.dataFilter.end_date ?? '')

                if (this.dataFilter.catalog_status && this.dataFilter.catalog_status.length > 0) {
                    this.dataFilter.catalog_status.forEach(status => {
                    params.append('catalog_status[]', status);
                    });
                }

                this.exportLink = `${baseUrl}?${params.toString()}`;

            }
		}
	};
</script>
